import { render, staticRenderFns } from "./SoR.vue?vue&type=template&id=42a3d992"
import script from "./SoR.vue?vue&type=script&lang=js"
export * from "./SoR.vue?vue&type=script&lang=js"
import style0 from "./SoR.vue?vue&type=style&index=0&id=42a3d992&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports